import deckSoundingSpots from './deckSoundingSpots.svg';
import engineSoundingSpots from './engineSoundingSpots.svg';
import soundings from './soundings.svg';

export default {
  soundings,
  deckSoundingSpots,
  engineSoundingSpots,
};
